import React, { PureComponent } from 'react';
import Home from './Home';
import PaperJs from './PaperJs';
import './Main.scss';
import { Route, Switch } from 'react-router';
import FabricJs from './FabricJs';

class Main extends PureComponent{
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home}></Route>
        <Route exact path="/paperJs" component={PaperJs}></Route>
        <Route exact path="/fabricJs" component={FabricJs}></Route>
      </Switch>
    )
  }
};

export default Main;
